import { render, staticRenderFns } from "./Glp.vue?vue&type=template&id=5fbbab03&"
import script from "./Glp.vue?vue&type=script&lang=js&"
export * from "./Glp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports